import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import MuiChip, { ChipProps as MuiChipProps } from '@mui/material/Chip';

import { Icon } from './Icon';

export function Chip<C extends React.ElementType = 'button'>(
  props: MuiChipProps<C, { component?: C; active?: boolean }>
) {
  const {
    color = 'secondary',
    clickable,
    sx,
    variant = 'soft',
    active = false,
    ...otherProps
  } = props;

  const internalColor = active ? 'primary' : color;
  const internalVariant = active ? 'soft' : variant;

  const styles = [
    internalColor === 'primary' &&
      internalVariant === 'outlined' && {
        borderColor: 'primary.main',
        color: 'primary.main',
      },
    {
      '& .MuiChip-deleteIcon': {
        fontSize: '16px',
        color: 'action.active',
      },
    },
    {
      '&. MuiChip-label': {
        display: 'flex',
        alignItems: 'center',
      },
    },
  ];

  return (
    <MuiChip
      sx={[...styles, ...(Array.isArray(sx) ? sx : [sx])]}
      variant={internalVariant}
      color={internalColor}
      clickable={clickable}
      deleteIcon={<Icon icon={icon({ name: 'times', style: 'regular' })} />}
      {...otherProps}
    ></MuiChip>
  );
}
